import React, { useEffect, useState } from 'react';
import './feedback.css'
import INCSUBSearchbar from '../../components/common/SearchBar/INCSUBSearchbar';
import INCSUBfeedbackCard from './feedbackCard';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getFeedbackList, putFeedbackAcknowledge } from '../../services/feedbackService';
import { useNavigate } from 'react-router';
import { setFeedbackList } from '../../features/feedback/feedbackSlice';
import INCSUBFeedbackDetailsCard from '../../components/feedback/feedbackDetailsCard';
import ReactPaginate from 'react-paginate';

function INCSUBfeedback() {
    const dispatch = useDispatch();
    const feedbackList = useSelector((state) => state.feedback.feedbackList);
    const navigate = useNavigate();
    const [isDetails, setIsDetails] = useState();
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [pageNo, setPageNo] = useState(0);
    const [searchKey, setSearchKey] = useState('');
    const [loader, setLoader] = useState(false)

    const fetchFeedbackList = async ({ searchKeyState = searchKey, pageState = pageNo } = {}) => {
        setLoader(true)
        try {
            const feedbackData = await getFeedbackList({ searchKey: searchKeyState, page: pageState });
            if (feedbackData.status === 200) {
                dispatch(setFeedbackList(feedbackData.data.data))
            } else if (feedbackData.status === 401) {
                navigate('/login');
                window.localStorage.setItem("userData", '')

            } else if (![200, 401].includes(feedbackData.status)) {
                toast.error(feedbackData.data.message)
            }
        } catch (err) {
            toast.error("Something went wrong");
        } finally {
            setLoader(false)
        }
    }
    useEffect(() => {
        fetchFeedbackList();
    }, [])
    const handleDetailView = (feedback) => {
        setIsDetails(true);
    }
    const handleSearchFeedBack = (key) => {
        setSearchKey((prevSearch) => {
            const newSearch = key;
            fetchFeedbackList({ searchKeyState: key }) // Pass the updated state if needed
            return newSearch;
        });
    }
    const [acknowledgeLoader, setAcknowledgeLoader] = useState(false)
    const setAcknowledge = async ({ userId, feedbackId, flag } = {}) => {
        if (acknowledgeLoader === true) {
            return
        }
        setAcknowledgeLoader(true);
        try {
            const acknowledgeData = await putFeedbackAcknowledge({ userId: userId, feedbackId: feedbackId, flag: flag });
            if (acknowledgeData.status === 200) {
                const updatedList = feedbackList.userFeedbackDataDtoList.map((feedback) =>
                    feedback.feedbackId === acknowledgeData.data.data.feedbackId
                        ? { ...feedback, ...acknowledgeData.data.data }
                        : feedback
                );
                dispatch(setFeedbackList({
                    ...feedbackList,
                    userFeedbackDataDtoList: updatedList
                }));
                if (selectedFeedback) {
                    setSelectedFeedback(acknowledgeData.data.data)
                }
            } else if (acknowledgeData.status === 401) {
                navigate('/login');
                window.localStorage.setItem("userData", '');
            } else if (![200, 401].includes(acknowledgeData.status)) {
                toast.error(acknowledgeData.data.message)
            }
        } catch (err) {
            toast.error("Something went wrong");
        } finally {
            setAcknowledgeLoader(false)
        }
    }
    /*Pagination Navigation*/
    const [currentPage, setCurrentPage] = useState(0);
    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(2);
        const endOffset = itemOffset;

        const pageCount = feedbackList ? feedbackList.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setPageNo(event.selected);
            fetchFeedbackList({ pageState: event.selected })
            setCurrentPage(event.selected)
            setItemOffset(event.selected);
        };

        return (

            <div className='INCSUBfeedback_list_section_container'>{
                !loader && feedbackList && feedbackList.userFeedbackDataDtoList && feedbackList.userFeedbackDataDtoList.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }



            </div>


        );
    }





    const renderedFeedbackCards = feedbackList && feedbackList.userFeedbackDataDtoList.length > 0 && feedbackList.userFeedbackDataDtoList?.map((feedback, index) => {
        return <INCSUBfeedbackCard feedback={feedback} index={index} func={handleDetailView} acknowledge={setAcknowledge} setSelectedFeedback={setSelectedFeedback} />
    })
    const handleOpenDetailFeedback = (e) => {
        setSelectedFeedback(false)
    }
    return (
        <div className='INCSUBFeedback_ctn'>
            <div className="INCSUBPools_Search_filters_container">
                <INCSUBSearchbar placeholder={'Search'} param={{ func: handleSearchFeedBack }} />
            </div>
            <div className='INCSUBFeedback_card_holder'>{
                loader ? <div className='feedbackLoader_container'><div className='feedbackLoader' /> </div> : (feedbackList && feedbackList.userFeedbackDataDtoList.length > 0 ? <div className='INCSUBFeedback_card_holder_scroller'>
                    {renderedFeedbackCards}
                </div> : <div className='INCSUBFeedback_empty'>No Feedback added yet</div>)
            }
            </div>
            <PaginatedItems />{
                selectedFeedback ? <INCSUBFeedbackDetailsCard feedback={selectedFeedback} acknowledge={setAcknowledge} handleFunc={handleOpenDetailFeedback} /> : null
            }

        </div>
    )
}

export default INCSUBfeedback
